var _excluded = ["label", "value", "onBlur", "onTimeChange", "onChange", "onError", "mountNode", "readOnly", "iconPosition", "minValue", "maxValue", "defaultMinValue", "defaultMaxValue", "timeRange", "startTime"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TimeInput } from 'semantic-ui-calendar-react';
import { Label, Popup } from "../..";
import Tooltip from "../Tooltip";
import { checkMinMaxValue } from "../../utils";
import InputMask from "../InputMask";

/**
* @deprecated  Veuillez utiliser SingleDatePicker ou DateRangePicker à la place.
*/
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Time = function Time(props) {
  var label = props.label,
    value = props.value,
    onBlur = props.onBlur,
    onTimeChange = props.onTimeChange,
    onChange = props.onChange,
    onError = props.onError,
    mountNode = props.mountNode,
    readOnly = props.readOnly,
    iconPosition = props.iconPosition,
    minValue = props.minValue,
    maxValue = props.maxValue,
    defaultMinValue = props.defaultMinValue,
    defaultMaxValue = props.defaultMaxValue,
    timeRange = props.timeRange,
    startTime = props.startTime,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _React$useState = React.useState(value),
    timeVal = _React$useState[0],
    setTimeVal = _React$useState[1];
  var _React$useState2 = React.useState(null),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    open = _React$useState3[0],
    setOpen = _React$useState3[1];
  var _React$useState4 = React.useState(0),
    actualPositionModal = _React$useState4[0],
    setActualPositionModal = _React$useState4[1];
  React.useEffect(function () {
    if (!_.isNil(error)) {
      if (onError && error === 'Erreur') {
        onError();
      }
      setError("Valeurs entre " + minValue + " et " + maxValue);
    }
  }, [minValue, maxValue, error, onError]);
  useEffect(function () {
    setTimeVal(value);
  }, [value]);
  var validateInput = React.useCallback(function (event, val) {
    if (!checkMinMaxValue(val, minValue, maxValue, defaultMinValue, defaultMaxValue, timeRange, startTime)) {
      setTimeVal(val);
      setError(null);
      // setOpen(false);
      if (onChange) {
        onChange(val);
      }
      if (onBlur) {
        // console.log(onB)
        onBlur(null, Object.assign({
          type: 'time'
        }, props, rest, {
          value: val
        }));
      }
      if (onTimeChange) {
        onTimeChange(event, Object.assign({
          type: 'time'
        }, props, rest, {
          value: val
        }));
      }
    } else {
      setError('Erreur');
      setTimeVal('00:00');
      setOpen(false);
    }
  }, [defaultMaxValue, defaultMinValue, maxValue, minValue, onBlur, onChange, onTimeChange, props, rest, startTime, timeRange]);
  var handleInputBlur = React.useCallback(function (event) {
    var _ref = event || {},
      target = _ref.target;
    var _ref2 = target || {},
      val = _ref2.value;
    if (!_.isNil(val)) {
      validateInput(event, val);
    }
  }, [validateInput]);
  React.useEffect(function () {
    if (!_.isNil(error)) {
      setActualPositionModal(0);
    }
  }, [error]);
  var handleInputChange = React.useCallback(function (event) {
    var _ref3 = event || {},
      target = _ref3.target;
    var _ref4 = target || {},
      val = _ref4.value;
    if (!_.isNil(val)) {
      if (onChange) {
        onChange(val);
      }
    }
  }, [onChange]);
  var handleTimeChange = React.useCallback(function (event, data) {
    var _ref5 = data || {},
      val = _ref5.value;
    setActualPositionModal(actualPositionModal + 1);
    if (actualPositionModal >= 1) {
      validateInput(event, val);
    } else if (actualPositionModal === 0) {
      setTimeVal(val);
      setError(null);
    }
  }, [actualPositionModal, validateInput]);
  var handleTimeClose = React.useCallback(function () {
    validateInput(null, timeVal);
    setActualPositionModal(0);
    setOpen(false);
  }, [validateInput, timeVal]);
  var handleTimeClick = React.useCallback(function () {
    if (open) {
      setActualPositionModal(0);
    }
    setOpen(!open);
  }, [open]);
  React.useEffect(function () {
    if (open && actualPositionModal >= 2) {
      setActualPositionModal(0);
      setOpen(false);
    }
  }, [open, actualPositionModal]);
  var inputMaskContent = React.useMemo(function () {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [function () {
        if (!_.isNil(label) && label !== '') {
          return /*#__PURE__*/_jsx(Label, {
            className: "labelTimePicker",
            children: label
          });
        }
        return null;
      }(), /*#__PURE__*/_jsx(Tooltip, {
        type: !_.isNil(error) ? 'error' : '',
        open: !_.isNil(error),
        message: error,
        trigger: /*#__PURE__*/_jsx(InputMask, Object.assign({}, rest, {
          mask: "99:99",
          maskPlaceholder: "0"
        }, !readOnly ? {
          icon: {
            name: 'time alternate outline',
            onClick: handleTimeClick,
            link: true
          },
          disabled: false,
          className: _.isNil(error) ? 'inputTimeNormal' : 'inputTimeError'
        } : {
          disabled: true,
          className: 'inputTimeDisabled'
        }, {
          value: timeVal,
          minValue: minValue,
          maxValue: maxValue,
          defaultMinValue: defaultMinValue,
          defaultMaxValue: defaultMaxValue,
          timeRange: timeRange,
          startTime: startTime,
          onChange: handleInputChange,
          onBlur: handleInputBlur,
          error: error,
          setError: setError
        }))
      })]
    });
  }, [rest, timeVal, minValue, maxValue, defaultMinValue, defaultMaxValue, timeRange, startTime, readOnly, label, handleTimeClick, handleInputChange, handleInputBlur, error]);
  return React.useMemo(function () {
    return /*#__PURE__*/_jsx(Popup, {
      open: open,
      trigger: /*#__PURE__*/_jsx("div", {
        style: {
          width: 170
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "inputTime",
          children: inputMaskContent
        })
      }),
      onClose: handleTimeClose,
      position: "bottom right",
      popperModifiers: {
        preventOverflow: {
          boundariesElement: 'window'
        }
      },
      on: "click",
      flowing: true,
      hoverable: true,
      style: {
        padding: 0
      },
      mountNode: mountNode,
      children: /*#__PURE__*/_jsx(TimeInput, {
        value: !_.isNil(timeVal) ? timeVal.toString() : '',
        onChange: handleTimeChange,
        animation: "",
        duration: 0,
        localization: "fr",
        initialDate: timeVal,
        closeOnMouseLeave: false,
        onClose: handleTimeClose,
        style: {
          width: '150px'
        },
        inline: true,
        disabled: readOnly
      })
    });
  }, [open, timeVal, inputMaskContent, readOnly, handleTimeClose, handleTimeChange, mountNode]);
};
Time.handledProps = ["maxValue", "minValue", "mountNode", "onBlur", "readOnly", "value"];
Time.propTypes = {
  /** Value. */
  value: PropTypes.string,
  /** Callback on blur. */
  onBlur: PropTypes.func,
  /** Read only. */
  readOnly: PropTypes.bool,
  mountNode: PropTypes.node
};
Time.defaultProps = {
  readOnly: false,
  minValue: '00:00',
  maxValue: '23:59'
};
export default Time;